// src/components/agent/AgentNavButton.jsx
// Logged out -> "Partner login" (opens modal). Logged in -> "Partner dashboard" link.
//
// variant: "pill" (desktop nav) | "menu" (mobile dropdown row) | "icon" (compact, small screens)
// onOpenLogin: pass it when the button lives inside something that unmounts on click
//              (like the mobile dropdown) so the modal is owned by the parent instead.
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Briefcase } from "lucide-react";
import AgentAuthModal from "./AgentAuthModal";
import { useAgentSession, partnerDashboardPath } from "../../utils/agentAuth";

const STYLES = {
  // styled in styles/Navbar.css, same shape as the Download App / Sign In buttons
  pill: "partner-nav-btn",
  icon:
    "inline-flex h-[42px] w-[42px] items-center justify-center rounded-lg border-[1.5px] border-[#FF5B15] bg-transparent " +
    "text-[#FF4E01] transition-colors hover:bg-[#FF4E01] hover:text-white",
  menu: "mobile-nav-link-btn",
};

export default function AgentNavButton({ variant = "pill", className = "", onNavigate, onOpenLogin }) {
  const session = useAgentSession();
  const [open, setOpen] = useState(false);
  const cls = `${STYLES[variant] || STYLES.pill} ${className}`.trim();
  const menuStyle = variant === "menu" ? { display: "flex", alignItems: "center", gap: 8 } : undefined;
  const iconOnly = variant === "icon";

  if (session) {
    return (
      <Link
        to={partnerDashboardPath(session.profile.user_id)}
        className={cls}
        style={menuStyle}
        onClick={onNavigate}
        aria-label="Partner dashboard"
        title="Partner dashboard"
      >
        <Briefcase size={iconOnly ? 17 : 15} />
        {!iconOnly && "Partner dashboard"}
      </Link>
    );
  }

  return (
    <>
      <button
        type="button"
        className={cls}
        style={menuStyle}
        aria-label="Partner login"
        title="Partner login"
        onClick={() => {
          onNavigate?.();
          if (onOpenLogin) onOpenLogin();
          else setOpen(true);
        }}
      >
        <Briefcase size={iconOnly ? 17 : 15} />
        {!iconOnly && "Partner login"}
      </button>
      {!onOpenLogin && <AgentAuthModal open={open} onClose={() => setOpen(false)} />}
    </>
  );
}
